<ng-container *ngIf="errorMsg; else resultTpl">
  <nz-result
    nzStatus="error"
    nzTitle="Teamcenter gave an error"
    [nzSubTitle]="errorMsg"
  ></nz-result>
</ng-container>

<ng-template #resultTpl>
  <nz-table
    #itemLogTable
    [nzData]="data"
    [nzLoading]="loading"
    nzSize="small"
    nzShowPagination="false"
  >
    <thead>
      <tr>
        <th>Code group</th>
        <th>Activity code</th>
        <th>Activity code text</th>
        <th>Activity text</th>
        <th>Created by</th>
        <th>Created on</th>
      </tr>
    </thead>
    <tbody class="em-no-table-row-hover">
      <ng-container *ngFor="let item of itemLogTable.data; trackBy: trackByRef">
        <tr>
          <td>{{ item.codeGroup }}</td>
          <td>{{ item.activityCode }}</td>
          <td>{{ item.activityCodeText }}</td>
          <td>{{ item.activityText }}</td>
          <td>{{ item.createdBy }}</td>
          <td>{{ item.createdOn | date: 'shortDate' }}</td>
        </tr>
      </ng-container>
    </tbody>
  </nz-table>
</ng-template>
